<shell-layout class="pt-12">
  <img class="error__img" src="assets/img/errors/error__page-not-found.svg" alt="" />
  <ui-text class="error__title" color="blue-500" size="h4" weight="semibold"
    >Página no encontrada</ui-text
  >
  <ui-text class="error__description" color="blue-300"
    >Hicimos nuestro mejor esfuerzo, pero no encontramos la página que estás buscando.</ui-text
  >
  <ui-button
    (clicked)="closeModal()"
    class="error__action"
    type="primary"
    label="Volver al inicio"
  ></ui-button>
</shell-layout>
